
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    lang: {
      type: String,
      required: true,
    },
  },
})
